<form class="form" [formGroup]="form()" tuiForm="l">
  <!--Sector-->
  <label tuiLabel tuiAppearance="ai-label">
    <span class="ai-label">Cфера деятельности</span>

    @let sectorControl = form().controls.sector;

    <tui-textfield [stringify]="sectorStringify" [tuiTextfieldCleaner]="false" tuiChevron>
      <input placeholder="Выберите сферу деятельности" tuiComboBox formControlName="sector" />

      <tui-data-list-wrapper
        *tuiTextfieldDropdown
        [items]="sectors() | tuiFilterByInput: sectorMatcher"
        tuiAppearance="ai-data-list-wrapper"
        size="m"
        emptyContent="Ничего не найдено"
        new
      />
    </tui-textfield>
  </label>

  @if (sectorControl.touched) {
    @if (sectorControl.hasError('required')) {
      <tui-error error="Это поле не может быть пустым"></tui-error>
    }
  }
  <!--Sector-->

  <!--Segment-->
  <label tuiLabel tuiAppearance="ai-label">
    <span class="ai-label">Сегмент</span>

    @let segmentControl = form().controls.segments;

    <tui-textfield
      [stringify]="stringifySegment"
      [disabledItemHandler]="isSegmentDropdownItemDisabled"
      [identityMatcher]="segmentIdentityMatcher"
      multi
      tuiChevron
    >
      <input
        [placeholder]="segmentControl.value?.length ? '' : 'Выберете сегмент'"
        formControlName="segments"
        tuiInputChip
      />

      <tui-input-chip *tuiItem appearance="ai-input-chip" />

      <ng-template tuiTextfieldDropdown>
        <tui-data-list-wrapper
          [items]="segments() | tuiFilterByInput: segmentMatcher"
          [itemContent]="itemContent"
          tuiAppearance="ai-data-list-wrapper"
          size="m"
          new
          tuiMultiSelectGroup
        />
      </ng-template>

      <ng-template #itemContent let-segment>
        {{ segment.name }}: {{ segment.reach | shortNumber }}
      </ng-template>
    </tui-textfield>
  </label>

  @if (segmentControl.touched) {
    @if (segmentControl.hasError('required')) {
      <tui-error error="Это поле не может быть пустым"></tui-error>
    }
  }
  <!--Segment-->

  <!--Platform-->
  <label tuiLabel tuiAppearance="ai-label">
    <span class="ai-label">Площадка</span>

    @let platformControl = form().controls.platform;

    <tui-textfield tuiChevron>
      <input
        tuiComboBox
        placeholder="Введите название площадки"
        formControlName="platform"
      />

      <tui-data-list-wrapper
        *tuiTextfieldDropdown
        new
        emptyContent="Ничего не найдено"
        [items]="platforms() | tuiFilterByInput"
      />
    </tui-textfield>
  </label>

  @if (platformControl.touched) {
    @if (platformControl.hasError('required')) {
      <tui-error error="Это поле не может быть пустым"></tui-error>
    }
  }
  <!--Platform-->

  <!--Comment-->
  <label tuiLabel tuiAppearance="ai-label">
    <span class="ai-label">Комментарий</span>

    @let commentControl = form().controls.comment;

    <tui-textfield class="form__textarea">
      <textarea
        [min]="0"
        [max]="0"
        formControlName="comment"
        placeholder="Напишите все, что считаете важным для вашего запроса"
        tuiTextarea
      ></textarea>
    </tui-textfield>
  </label>

  @if (commentControl.touched) {
    @if (commentControl.hasError('required')) {
      <tui-error error="Это поле не может быть пустым"></tui-error>
    }
  }
  <!--Comment-->

  <footer class="form__footer">
    <button
      [disabled]="!form().valid"
      [loading]="isLoading()"
      (click)="buildAudience.emit()"
      tuiButton
      type="submit"
      appearance="ai-primary"
    >
      Подобрать аудитории
    </button>
    <button (click)="openSegmentModal.emit()" tuiButton type="button" appearance="ai-secondary">
      Не нашел подходящий сегмент
    </button>
  </footer>
</form>
